import type { $ } from "../../../dom";
import { MultiInput, type MultiInputOptions } from "../../core";
import { ButtonInput } from "./button-input";

export type ButtonGroupInputOptions<TValue> = MultiInputOptions<TValue> & {};

export abstract class ButtonGroupInput<
  TValue,
  TData = TValue,
> extends MultiInput<TValue, TData> {
  public abstract inputs: ButtonInput<TValue, TData>[];

  constructor($root: $, options?: ButtonGroupInputOptions<boolean[]>) {
    const { ...superOptions } = options ?? {};

    super($root, superOptions);
  }

  toggleAll(value: boolean): void {
    this.inputs.forEach((input) => {
      input.isActive = value;
    });
  }
}
